// extracted by mini-css-extract-plugin
export var Schematic = "styles-module--Schematic--34erk";